import { closingColon } from "./helpers.js"
import { StyleOperations } from "./styles.js"

export const HeadingOperations = {

  isTrue: arg => {
    // check if it's a div
    let matcher = /\bmn[123456]+\b/g
    return matcher.test(arg)
  },
  /**
   * When you detect an opening colon, use a stack to find it's closing semi colon
   * box:
   */
  hasOpened: true,

  // FIXME: should account for the classname and the inline styles

  getHeading: arg => {
    arg = arg.trim().split(" ")
    let heading = arg[0]
    return heading
  },

  openingColon: arg => {
    let heading = HeadingOperations.getHeading(arg);
    arg = arg.replace(heading, `<${heading} `).replace(":", "")
    console.log(arg, " is -------------");
    arg = arg.replace(/mn/,"h")
    return arg
  },
}

export const runHeadingOperations = (readLinesOriginal, readLines, errors) => {
  for (var i = 0; i < readLines.length; i++) {
    let x = readLines[i]
    if (HeadingOperations.isTrue(x)) {
      let heading = HeadingOperations.getHeading(x)
      closingColon(readLines, i, HeadingOperations, `/${heading}>`);
      console.log(HeadingOperations.openingColon(x), " --------------", "this")
      readLines[i] = HeadingOperations.openingColon(x)
    } else {
    }
  }
  return readLines
}
